import { Component, Vue } from "vue-property-decorator";
import { TranslationModel, ProductModel } from "../models/product";
import { productStore } from "@/store/ProductModule";
import QuantityCalculatorUBlockProduct from "./QuantityCalculatorUBlockProduct";
import { EventBus } from "../events";

@Component({
    components: {
        QuantityCalculatorUBlockProduct,
    }
})
export default class QuantityCalculatorUBlockProductContainer extends Vue {
    protected vm: any = {};
    protected isModalVisible: boolean = false;
    protected calculatorUrl: string = "/ui/img/site/Calculator.png";
    private translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    get product(): ProductModel {
        return productStore.product;
    }

    protected showModal() {
        this.isModalVisible = true;
    }

    protected closeModal() {
        this.isModalVisible = false;
    }

    protected mounted() {
        EventBus.$on("hideUBlockCalculator", () => {
            this.isModalVisible = false;
        });
    }
}
